import React from "react";
import "./Icon.css";
import { cssHost } from "../../utils/config";

// Per-deploy asset path segment, injected ONLY by the new (Vite) build as
// "static/<version>" so public images resolve to the cache-busted, 1-year
// immutable /static tree. The legacy Parcel build does not set it, so it falls
// back to the unversioned root path and its output is unchanged.
const assetVersion = process.env.LEAD360_ASSET_VERSION;

const Icon = ({ src, alt, width = 24, height = 24, color }) => {
  const iconSrc = assetVersion
    ? `${cssHost}/${assetVersion}/${src}`
    : `${cssHost}/${src}`;
  return (
    <div
      className={`lead360IconWrapper ${color}`}
      style={{
        width: width,
        height: height,
      }}
    >
      <img src={iconSrc} alt={alt} data-testid="lead360-icon" />
    </div>
  );
};

export default Icon;
